import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarHeading,
  ToolbarDescription,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";
import { useLayout } from "@/providers";
import { RegistrationListings } from "./RegistrationListings.tsx";
import { BackButton } from "@/components/button";

const RegistrationManagement = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />

      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <div className="flex items-center gap-3">
                <BackButton customBackPath="/club-management" />
                <div>
                  <ToolbarPageTitle text="Yacht Club Registrations" />
                  <ToolbarDescription>
                    Manage incoming club registrations here.
                  </ToolbarDescription>
                </div>
              </div>
            </ToolbarHeading>
          </Toolbar>

          <div className="mt-6">
            <RegistrationListings />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export default RegistrationManagement;
